<template>
  <div @mouseover="mouseoverSidemenu()" @mouseleave="mouseleaveSidemenu()">
    <user-token-site-name :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="side-menu" :class="[dark_mode ? 'dark' : '', header_notification ? 'header-notification-space' : '', isSideMenuClosed ? 'collapsed' : '']">
      <div class="router-push">
        <div :class="[isOem ? 'logo-wrap-oem' : 'logo-wrap', isSideMenuClosed ? 'collapsed' : '']">
          <img :src="[dark_mode ? darkLogo : logo]" :class="[isOem ? 'logo-oem' : 'logo', isSideMenuClosed ? 'collapsed' : '']" @click="routerPush('/')" />
          <p v-show="!isOem && !isSideMenuClosed" :class="[dark_mode ? 'logofont dark' : 'logofont']">{{logoText}}</p>
          
          <p @click="toggleCollapse" @mouseover="mouseoverCollapseIcon()" @mouseleave="mouseleaveCollapseIcon()" class="collapse-icon" :class="isSideMenuClosed ? 'collapsed' : ''">
            <font-awesome-icon :icon="collapseIcon" :class="dark_mode ? 'dark' : ''" />
          </p>
        </div>
      </div>
      <div class="side-menu-menu" id="sidemenu">
        <el-menu unique-opened @open="changeOpeneds" @close="closeOpeneds" :default-openeds="openMenu">
          <div class="divider sidedivider top" :class="[dark_mode ? 'dark' : '']"></div>
          <div class="router-push" @click="routerPush('/dashboard')">
            <el-menu-item index="1" :class="[activeMenu == 'dashboard' ? 'isActive' : '', dark_mode ? 'dark' : '']" @click="changeActive('dashboard')">
              <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']"><i class="el-icon-s-home"></i></div>
              <span v-show="!isSideMenuClosed">{{ language == "jp" ? "ダッシュボード" : "Dashboard" }}</span>
            </el-menu-item>
          </div>
          <el-tooltip placement="right" :disabled="search_enabled">
            <div class="activate-popover" slot="content">
              <div class="pointer" @click="toSetting">アップグレード</div>
              でご利用いただけます
            </div>
            <el-submenu index="2" :class="[activeMenu == 'i_search' ? 'isActive is-opened' : '', dark_mode ? 'dark' : '']">
              <template slot="title">
                <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']"><i class="el-icon-search title-icon-i"></i></div>
                <span slot="title" :class="[dark_mode ? 'dark' : '']">{{ language == "jp" ? "インフルエンサー検索" : "Influencer Discovery" }}</span>
              </template>
              <div :class="[dark_mode ? 'side-search-form dark' : 'side-search-form']" v-if="search_influencer_instagram_enabled">
                <div class="side-search-form-box">
                  <div class="sns-button-wrap">
                    <div class="pointer sns-button" @click="snsType('instagram')" :class="[sns_type == 'instagram' ? 'active' : '', dark_mode ? 'dark' : '']">
                      <font-awesome-icon :icon="['fab', 'instagram']" style="margin-right:1px; font-size:16px" />
                    </div>
                    <el-tooltip placement="right" :disabled="search_influencer_youtube_enabled">
                      <div class="activate-popover" slot="content">
                        <div class="pointer" @click="toSetting">アップグレード</div>
                        でご利用いただけます
                      </div>
                      <div class="pointer sns-button center" @click="search_influencer_youtube_enabled ? snsType('youtube') : null" :class="[sns_type == 'youtube' ? 'active' : '', dark_mode ? 'dark' : '']">
                        <font-awesome-icon :icon="['fab', 'youtube']" style="margin-right:1px; font-size:16px" />
                      </div>
                    </el-tooltip>
                    <el-tooltip placement="right" :disabled="search_influencer_tiktok_enabled">
                      <div class="activate-popover" slot="content">
                        <div class="pointer" @click="toSetting">アップグレード</div>
                        でご利用いただけます
                      </div>
                      <div class="pointer sns-button center" @click="search_influencer_tiktok_enabled ? snsType('tiktok') : null" :class="[sns_type == 'tiktok' ? 'active' : '', dark_mode ? 'dark' : '']">
                        <font-awesome-icon :icon="['fab', 'tiktok']" style="margin-right:1px; font-size:16px" />
                      </div>
                    </el-tooltip>
                    <el-tooltip placement="right" :disabled="search_influencer_x_enabled">
                      <div class="activate-popover" slot="content">
                        <div class="pointer" @click="toSetting">アップグレード</div>
                        でご利用いただけます
                      </div>
                      <div class="pointer sns-button right" @click="search_influencer_x_enabled ? snsType('twitter') : null" :class="[sns_type == 'twitter' ? 'active' : '', dark_mode ? 'dark' : '']">
                        <svg width="13" height="13" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor"/>
                        </svg>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
                <sidemenuInstagram v-show="sns_type == 'instagram'" />
                <sidemenuYouTube v-show="sns_type == 'youtube'" />
                <sidemenuTikTok v-show="sns_type == 'tiktok'" />
                <sidemenuTwitter v-show="sns_type == 'twitter'" />
              </div>
            </el-submenu>
          </el-tooltip>
          <el-tooltip placement="right" :disabled="search_post_enabled">
            <div class="activate-popover" slot="content">
              <div class="pointer" @click="toSetting">アップグレード</div>
              でご利用いただけます
            </div>
            <el-submenu v-model="isSubmenuOpen" index="3" :class="[activeMenu == 'media_search' ? 'isActive is-opened' : '', dark_mode ? 'dark' : '']">
              <template slot="title">
                <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']">
                  <i class="el-icon-picture-outline-round title-icon-i"></i>
                </div>
                <span :class="[dark_mode ? 'dark' : '']">{{ language == "jp" ? "クリエイティブ検索" : "Media Discovery" }}</span>
              </template>
              <div class="side-search-form" :class="dark_mode ? 'dark' : ''" v-if="search_post_enabled">
                <div class="side-search-form-box">
                  <div class="sns-button-wrap">
                    <el-tooltip placement="top" content="フィード投稿">
                      <div class="pointer sns-button" @click="postType('feed')" :class="[post_type == 'feed' ? 'active' : '', dark_mode ? 'dark' : '']">
                        <font-awesome-icon :icon="['far', 'table-cells']" style="margin-right:1px; font-size:16px" />
                      </div>
                    </el-tooltip>
                    <el-tooltip placement="top" content="リール投稿">
                      <div class="pointer sns-button center" @click="postType('reel')" :class="[post_type == 'reel' ? 'active' : '', dark_mode ? 'dark' : '']">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="height:60%;" fill="currentColor" >
                          <path d="M448 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V96C512 60.65 483.3 32 448 32zM254.1 80h67.88l-80 80H174.1L254.1 80zM48 126.1L94.06 80h67.88l-80 80H48V126.1zM464 416c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V208h416V416zM464 97.94L401.9 160h-67.88l80-80H448c8.822 0 16 7.178 16 16V97.94zM218.7 400c1.959 0 3.938-.5605 5.646-1.682l106.7-68.97C334.1 327.3 336 323.8 336 319.1s-1.896-7.34-5.021-9.354l-106.7-68.97C221.1 239.5 216.9 239.5 213.5 241.4C210.1 243.3 208 247 208 251v137.9c0 4.008 2.104 7.705 5.5 9.656C215.1 399.5 216.9 400 218.7 400z"/>
                        </svg>                    
                      </div>
                    </el-tooltip>
                  </div>
                </div>
                <sidemenuPost v-show="post_type == 'feed'" />
                <sidemenuReel v-show="post_type == 'reel'" />
              </div>
            </el-submenu>
          </el-tooltip>
          
          <el-tooltip placement="right" :disabled="view_influencer_list_enabled">
            <div class="activate-popover" slot="content">
              <div class="pointer" @click="toSetting">アップグレード</div>
              でご利用いただけます
            </div>
            <div :class="[dark_mode ? 'divider dark sidedivider' : 'divider sidedivider']"></div>
            <div class="router-push" @click="view_influencer_list_enabled ? routerPush('/list') : ''">
              <el-menu-item index="4" :class="[activeMenu == 'list' ? 'isActive' : '', dark_mode ? 'dark' : '']" @click="changeActive('list')">
                <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']"><i class="el-icon-document"></i></div>
                <span v-show="!isSideMenuClosed">{{ language == "jp" ? "インフルエンサーリスト" : "Influencer Management" }}</span>
              </el-menu-item>
            </div>
          </el-tooltip>
          
          <div class="router-push" @click="routerPush('/report')">
            <el-menu-item index="5" :class="[activeMenu == 'report' ? 'isActive' : '', dark_mode ? 'dark' : '']" @click="changeActive('report')">
              <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']">
                <font-awesome-icon :icon="['fas', 'analytics']" style="margin-left:-5px; width: 28px;" />
              </div>
              <span v-show="!isSideMenuClosed">{{ language == "jp" ? "レポート・トラッキング" : "Tracking" }}</span>
            </el-menu-item>
          </div>
          <el-tooltip placement="right" :disabled="view_dm_enabled">
            <div class="activate-popover" slot="content">
              <div class="pointer" @click="toSetting">アップグレード</div>
              でご利用いただけます
            </div>
            <div class="router-push" @click="view_dm_enabled ? routerPush('/message') : ''">
              <el-menu-item index="6" :class="[activeMenu == 'message' ? 'isActive' : '', dark_mode ? 'dark' : '']" @click="activate > 10 ? changeActive('message') : ''">
                <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']">
                  <font-awesome-icon :icon="['fas', 'paper-plane']" style="margin-left:-5px; width: 28px;" />
                </div>
                <span v-show="!isSideMenuClosed">{{ language == "jp" ? "ダイレクトメッセージ" : "Direct Message" }}</span>
              </el-menu-item>
            </div>
          </el-tooltip>
          
          <el-tooltip placement="right" :disabled="view_request_enabled">
            <div class="activate-popover" slot="content">
              <div class="pointer" @click="toSetting">アップグレード</div>
              でご利用いただけます
            </div>
            <div class="router-push" @click="view_request_enabled ? routerPush('/request') : ''">
              <el-menu-item index="7" :class="[activeMenu == 'request' ? 'isActive' : '', dark_mode ? 'dark' : '']" @click="changeActive('request')">
                <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']">
                  <font-awesome-icon :icon="['fal', 'user-plus']" style="margin-left:-5px; font-size:12px; width: 28px;" />
                </div>
                <span v-show="!isSideMenuClosed">{{ language == "jp" ? "リクエスト・インポート" : "Request and Import" }}</span>
              </el-menu-item>
            </div>
          </el-tooltip>
          
          <div :class="[dark_mode ? 'divider dark sidedivider' : 'divider sidedivider']"></div>
          <div class="router-push" @click="routerPush('/setting')">
            <el-menu-item index="8" :class="[activeMenu == 'setting' ? 'isActive' : '', dark_mode ? 'dark' : '']" @click="changeActive('setting')">
              <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']"><i class="el-icon-office-building"></i></div>
              <span v-show="!isSideMenuClosed">{{ language == "jp" ? "ご利用プラン・会社情報" : "Company Setting" }}</span>
            </el-menu-item>
          </div>
          <div class="router-push" @click="routerPush('/account_setting')">
            <el-menu-item index="9" :class="[activeMenu == 'account_setting' ? 'isActive' : '', dark_mode ? 'dark' : '']" @click="changeActive('setting')">
              <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']"><i class="el-icon-setting"></i></div>
              <span v-show="!isSideMenuClosed">{{ language == "jp" ? "アカウント設定" : "Account Setting" }}</span>
            </el-menu-item>
          </div>
          <a href="https://help.reech.co.jp/ja/collections/1891943-reech-database-q-a" target="_blank">
            <el-menu-item index="10" :class="[dark_mode ? 'dark' : '']">
              <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']">
                <font-awesome-icon :icon="['fal', 'question-circle']" style="margin-left:-5px; font-size:16px; width: 28px;" />
              </div>
              <span v-show="!isSideMenuClosed">{{ language == "jp" ? "ヘルプセンター" : "Helpcenter" }}</span>
            </el-menu-item>
          </a>
          <el-menu-item v-show="!isOem" index="11" :class="[dark_mode ? 'dark' : '']" @click="reportError()">
            <div :class="[dark_mode ? 'title-icon dark' : 'title-icon']">
              <font-awesome-icon :icon="['fal', 'debug']" style="margin-left:-5px; font-size:16px; width: 28px;" />
            </div>
            <span v-show="!isSideMenuClosed">{{ language == "jp" ? "不具合・エラーを報告" : "Report Defects" }}</span>
          </el-menu-item>
        </el-menu>

        <div class="side-menu-bottom">
          <div>
            <a :href=privacyPolicyUrl target="_blank" class="side-menu-pointer">{{ language == "jp" ? "プライバシーポリシー" : "Privacy Policy" }}</a>
            <el-divider direction="vertical"></el-divider>
            <a :href=termsOfUseUrl target="_blank" class="side-menu-pointer">{{ language == "jp" ? "利用規約" : "Terms" }}</a>
          </div>
          <div style="margin-top:5px" v-show="!isOem">©︎2020 REECH Inc. All Rights Reserved.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidemenuInstagram from "./sidemenu_instagram";
import sidemenuYouTube from "./sidemenu_youtube";
import sidemenuTikTok from "./sidemenu_tiktok";
import sidemenuTwitter from "./sidemenu_twitter";
import sidemenuPost from "./sidemenu_post";
import sidemenuReel from "./sidemenu_reel";
import UserTokenSiteName from "@/components/oem/UserTokenSiteInfo.vue";

export default {
  name: "sidemenu",
  components: {
    sidemenuInstagram,
    sidemenuYouTube,
    sidemenuTikTok,
    sidemenuTwitter,
    sidemenuPost,
    sidemenuReel,
    UserTokenSiteName,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      darkLogo: "",
      logo: "",
      logoText: "",
      language: "jp",
      privacyPolicyUrl: "https://reech.co.jp/privacypolicy/",
      termsOfUseUrl: "https://reech.co.jp/term/",
      isOem: false,
      isCollapseIconMouseOver: false, // 追加
      isSubmenuOpen: false, // サブメニューの開閉状態を管理
    };
  },
  computed: {
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    activeMenu() {
      return this.$store.state.activeMenu;
    },
    activate() {
      return this.$store.state.activate;
    },
    openMenu() {
      return this.$store.state.openMenu;
    },
    isSideMenuClosed() {
      return this.$store.state.isSideMenuClosed;
    },
    sns_type() {
      return this.$store.state.sns_type;
    },
    post_type() {
      return this.$store.state.post_type;
    },
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    app_ver() {
      return this.$store.state.app_ver;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    search_influencer_instagram_enabled() {
      return this.$store.state.service_plan.search_influencer_instagram_enabled;
    },
    search_influencer_youtube_enabled() {
      return this.$store.state.service_plan.search_influencer_youtube_enabled ? true : false;
    },
    search_influencer_tiktok_enabled() {
      return this.$store.state.service_plan.search_influencer_tiktok_enabled ? true : false;
    },
    search_influencer_x_enabled() {
      return this.$store.state.service_plan.search_influencer_x_enabled ? true : false;
    },
    search_post_enabled() {
      return this.$store.state.service_plan.search_post_enabled ? true : false;
    },
    view_dm_enabled() {
      return this.$store.state.service_plan.view_dm_enabled ? true : false;
    },
    view_influencer_list_enabled() {
      return this.$store.state.service_plan.view_influencer_list_enabled ? true : false;
    },
    view_request_enabled() {
      return this.$store.state.service_plan.view_request_enabled ? true : false;
    },
    search_enabled() {
      if(
        this.search_influencer_instagram_enabled || 
        this.search_influencer_youtube_enabled ||
        this.search_influencer_tiktok_enabled ||
        this.search_influencer_x_enabled) return true;
      return false;
    },
    collapseIcon() {
      if (this.isSideMenuClosed) {
        return this.isCollapseIconMouseOver ? ['fas', 'arrow-right'] : ['fas', 'bars'];
      } else {
        return this.isCollapseIconMouseOver ? ['fas', 'arrow-left'] : ['fas', 'bars'];
      }
    },
  },
  mounted() {
    this.$store.dispatch("loadSidemenuOption", this.token);
  },
  methods: {
    snsType(value) {
      this.$store.dispatch("snsType", value);
    },
    postType(value) {
      this.$store.dispatch("postType", value);
    },
    changeActive(value) {
      this.$store.dispatch("changeActive", value);
      if (["list", "setting", "dashboard", "campaign", "report", "message", "request"].includes(this.activeMenu)) {
        this.$store.dispatch("changeOpeneds", []);
      }
    },
    changeOpeneds(index) {
      if (this.activate > 10) {
        this.$store.dispatch("changeOpeneds", [index]);
      }
    },
    changeIsSideMenuClosed(value) {
        this.$store.dispatch("changeIsSideMenuClosed", value);
    },
    closeOpeneds() {
      this.$store.dispatch("changeOpeneds", []);
    },
    toSetting() {
      this.$router.push("/setting");
    },
    routerPush(path) {
      this.$router.push(path);
    },
    sidemenuScroll(sns_type) {
      var element = document.getElementById("sidemenu");
      element.scroll({
        //画面を上部に移動
        top: 0,
        behavior: "instant",
      });
      if (sns_type == "instagram") {
        this.iSearch();
      } else {
        this.ySearch();
      }
    },
    mouseoverSidemenu() {
      document.documentElement.style.overflow = "hidden";
    },
    mouseleaveSidemenu() {
      document.documentElement.style.overflow = "auto";
    },
    mouseoverCollapseIcon() {
      this.isCollapseIconMouseOver = true;
    },
    mouseleaveCollapseIcon() {
      this.isCollapseIconMouseOver = false;
    },
    reportError() {
      this.$intercom.show();
    },
    updateSiteInfo({termsOfUseUrl, privacyPolicyUrl, darkLogo, logo, logoText, oemDarkLogo, oemLogo, isOem}) {      
      this.termsOfUseUrl = termsOfUseUrl;
      this.privacyPolicyUrl = privacyPolicyUrl;
      this.darkLogo = darkLogo;
      this.logo = logo;
      this.logoText = logoText;      
      this.oemDarkLogo = oemDarkLogo;
      this.oemLogo = oemLogo;
      this.isOem = isOem;
    },
    toggleCollapse() {
      if(!this.isSideMenuClosed) {
        // サイドメニューを閉じる際、サブメニューが開いていた場合は閉じる
        this.$store.dispatch("changeOpeneds", []);
      }
      this.changeIsSideMenuClosed(!this.isSideMenuClosed);
    }
  },
  watch: {
    activeMenu() {
      this.$forceUpdate();
    },
    openMenu() {
      // サイドメニューが縮小されている状態でサブメニューを開く場合は、サイドメニューを展開する
      if (this.isSideMenuClosed === true && this.openMenu.length > 0) {
        this.changeIsSideMenuClosed(false);
        
        // OEMの場合はロゴの画像パスをロゴ画像に切り替える
        if(this.isOem) {
          this.logo = this.oemLogo;
          this.darkLogo = this.oemDarkLogo;
        }
      }      
      this.$forceUpdate();
    },
  },
};
</script>